module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_ID.e427da97.png";